import React from "react";
import { connect } from "react-redux";
import {Header,SideNavbar} from '../index';
import { bindActionCreators } from "redux";
import axios from 'axios';
import { kinetik_api_url } from '../utilities/const';
import { Redirect } from 'react-router-dom';



class HomeWrapper extends React.Component {
    constructor(props){
        super(props);
        this.state={
          tokenCheck:true,
        }
      }
      componentWillMount=()=>{
        this.tokenExpiryCheck()
      }
      tokenExpiryCheck=()=>{
        const token = localStorage.getItem('authToken');
        return new Promise(resolve=>{
            console.log("token check req",kinetik_api_url+'/tokenCheck?token='+token);
          axios.get(kinetik_api_url+'/tokenCheck?token='+token).then((res)=>{
            console.log("res from token Check",res)
            if(res.data.status!=='success'){
              this.setState({tokenCheck:false})
            }
            resolve();
          })
        })
      }
  render=()=> {
   
       if(this.state.tokenCheck===false || localStorage.getItem('authToken') === null){
       return <Redirect to="/logout" />
        }
  
      return (
        <div>
          <Header />
          <SideNavbar />
          <div className="body-content">
            <div className="page-title">Dashboard</div>
            {(this.props.provider_info!==null)&&<div className="page-subtitle">Welcome {this.props.provider_info.company_name}</div>} 
            <p className="version-text">v1.13</p>
          </div>
        </div>
      );
  }
}

const mapStateToProps = state => {
  return {
    provider_info: state.userData.provider_info
  };
};
function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
    },
    dispatch
  );
}

export default connect(mapStateToProps,mapDispatchToProps)(HomeWrapper);



// WEBPACK FOOTER //
// ./src/app/home/HomeWrapper.js